"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var reduceLeftPadding = function reduceLeftPadding() {
  return (0, _styledComponents.css)(["padding-left:8px;"]);
};

var reduceRightPadding = function reduceRightPadding() {
  return (0, _styledComponents.css)(["padding-right:8px;"]);
};

var ChipWrapper = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Chip__ChipWrapper",
  componentId: "sc-1tgaxaz-0"
})(["text-transform:none;padding:0 12px;flex-shrink:0;", " ", ""], function (_ref) {
  var leadingIcon = _ref.leadingIcon;
  return leadingIcon && reduceLeftPadding();
}, function (_ref2) {
  var trailingIcon = _ref2.trailingIcon;
  return trailingIcon && reduceRightPadding();
});
var ChipText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Chip__ChipText",
  componentId: "sc-1tgaxaz-1"
})(["", ""], function (_ref3) {
  var hideOverFlow = _ref3.hideOverFlow;
  return hideOverFlow ? "overflow: hidden; text-overflow: ellipsis; white-space: nowrap; position: relative;" : "";
});

var Chip = function Chip(_ref4) {
  var children = _ref4.children,
      isActive = _ref4.isActive,
      palette = _ref4.palette,
      hideOverFlow = _ref4.hideOverFlow,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref4, ["children", "isActive", "palette", "hideOverFlow"]);
  return _react["default"].createElement(ChipWrapper, (0, _extends2["default"])({}, props, {
    hideOverFlow: hideOverFlow,
    borderRadius: 99,
    height: 32,
    elevation: 0,
    variant: isActive ? palette.active + ".1" : palette.inactive + ".6"
  }), _react["default"].createElement(ChipText, {
    fontSize: 3,
    fontWeight: 400,
    color: "dark.2",
    width: hideOverFlow ? 4 / 5 : "inherit",
    textAlign: "left",
    hideOverFlow: hideOverFlow
  }, children));
};

Chip.defaultProps = {
  isActive: false,
  palette: {
    active: "secondary",
    inactive: "dark"
  }
};
Chip.propTypes = {
  isActive: _propTypes["default"].bool,
  palette: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    inactive: _propTypes["default"].string
  })
};
var _default = Chip;
exports["default"] = _default;